import React, { useState, useEffect, useContext } from 'react';
import { ModeContext } from './ModeContext';
import { 
  Box, 
  Typography, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper, 
  Chip, 
  CircularProgress,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  Badge,
  Tooltip
} from '@mui/material';
import { Edit as EditIcon, ArrowUpward, ArrowDownward } from '@mui/icons-material';
import { SupportAgent,AssignmentTurnedIn,DirectionsCar,Engineering,Autorenew,
  LocalShipping as SendbackIcon,
  Schedule as ScheduleIcon,
  CheckCircle as CompleteIcon,
  Cancel as CancelIcon
} from '@mui/icons-material';
import { LoadToCosmos, SendToCosmos } from './SendToCosmos';
import { updateRequestStatus } from './RequestSupportSend';

const RequestDisplay = () => {
  const { loginInfo, requestStatusFilter, setRequestStatusFilter, setRequestStatusCounts, setUnreadCommentCount } = useContext(ModeContext);
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [allRequests, setAllRequests] = useState([]); // フィルター前の全データ
  const [companyFilter, setCompanyFilter] = useState(''); // 企業名フィルター
  const [userFilter, setUserFilter] = useState(''); // ユーザー名フィルター
  const [availableCompanies, setAvailableCompanies] = useState([]); // 利用可能な企業名リスト
  const [availableUsers, setAvailableUsers] = useState([]); // 利用可能なユーザー名リスト
  const [reqActionStatuses, setReqActionStatuses] = useState({}); // con-concierge-reqactionのステータスマップ
  const [searchText, setSearchText] = useState(''); // 文言検索用
  const [statusFilter, setStatusFilter] = useState(''); // 状態フィルター用
  
  // 日付フィルターのデフォルト値を計算
  const getDefaultDateFrom = () => {
    const date = new Date();
    date.setDate(date.getDate() - 14); // 14日前
    return date.toISOString().split('T')[0];
  };
  
  const getDefaultDateTo = () => {
    const date = new Date();
    return date.toISOString().split('T')[0]; // 当日
  };
  
  const [dateFrom, setDateFrom] = useState(getDefaultDateFrom()); // 日付From（デフォルト14日前）
  const [dateTo, setDateTo] = useState(getDefaultDateTo()); // 日付To（デフォルト当日）
  
  // モーダル関連の状態
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [editedContent, setEditedContent] = useState('');
  const [editedStatus, setEditedStatus] = useState('');
  const [editedActionNumber, setEditedActionNumber] = useState(''); // アクション番号
  const [saving, setSaving] = useState(false);
  const [comments, setComments] = useState([]); // コメント一覧
  const [newComment, setNewComment] = useState(''); // 新規コメント入力
  
  // ソート関連の状態
  const [sortField, setSortField] = useState('timestamp'); // デフォルトは依頼日時
  const [sortOrder, setSortOrder] = useState('desc'); // デフォルトは降順

  // con-concierge-reqactionからステータスを取得する関数
  const fetchReqActionStatuses = async () => {
    try {
      const payload = { 
        id: 'all', 
        container: 'con-concierge-reqaction' 
      };
      
      const result = await LoadToCosmos(payload);
      console.log('=== con-concierge-reqaction取得結果 ===', result);
      
      if (result && result.item) {
        const statusMap = {};
        
        // 配列の場合
        if (Array.isArray(result.item)) {
          result.item.forEach(item => {
            if (item.id) {
              statusMap[item.id] = item.status;
            }
          });
        } 
        // 単一オブジェクトの場合
        else if (result.item.id) {
          statusMap[result.item.id] = result.item.status;
        }
        
        console.log('=== ステータスマップ ===', statusMap);
        setReqActionStatuses(statusMap);
      }
    } catch (error) {
      console.error('con-concierge-reqactionの取得エラー:', error);
      setReqActionStatuses({});
    }
  };

  // 依頼進捗データを取得
  const fetchRequests = async () => {
    try {
      setLoading(true);
      
      let payload;
      if (loginInfo.authorityId === 'admin') {
        // 管理者は全ての企業のデータを取得
        payload = { 
          id: 'all', 
          container: 'con-concierge-request' 
        };
      } else {
        // HQ/storeは自分の企業のデータのみ取得
        payload = { 
          id: loginInfo.compId, 
          container: 'con-concierge-request' 
        };
      }

      const result = await LoadToCosmos(payload);
      
      // Admin権限の場合の処理
      if (loginInfo.authorityId === 'admin' && result && result.item ) {
        // 管理者は全ての企業のデータを統合
        const allRequests = [];
        const companies = new Set();
        const users = new Set();
        console.log('MKkita',result);
        
        result.item.forEach(companyData => {
          console.log('Admin processing companyData:', companyData.messages);
          console.log('Admin processing ID', companyData.id);
          console.log('Admin processing compName', companyData.compName);
          
          companies.add(companyData.compName || companyData.id); // 企業名を優先
          Object.entries(companyData.messages).forEach(([storeId, storeData]) => {
            console.log('Admin1', storeId);
            console.log('Admin2', storeData);
            
            if (storeData.userName) {
              users.add(storeData.userName);
            }
            
            if (storeData.messages && Array.isArray(storeData.messages)) {
              storeData.messages.forEach(category => {
                if (category.messages && Array.isArray(category.messages)) {
                  category.messages.forEach(request => {
                    allRequests.push({
                      ...request,
                      type: category.category === 'sendbak' ? 'センドバック' : 'サポート',
                      category: category.category,
                      storeId: storeId,
                      companyId: companyData.id,
                      companyName: companyData.compName || companyData.id, // 企業名を追加
                      userName: storeData.userName || '-' // ユーザー名を追加
                    });
                  });
                }
              });
            }
          });
        });
        
        console.log('Admin companies:', Array.from(companies));
        console.log('Admin users:', Array.from(users));
        console.log('Admin allRequests:', allRequests);
        
        // タイムスタンプで降順ソート（新しい順）
        allRequests.sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));
        
        setAllRequests(allRequests);
        setAvailableCompanies(Array.from(companies).sort());
        setAvailableUsers(Array.from(users).sort());
        setRequests(allRequests);
        
      } else if (loginInfo.authorityId === 'admin' && result && result.item) {
        // Admin権限で単一企業データの場合の処理
        console.log('Admin single company data:', result.item);
        const allRequests = [];
        const companies = new Set();
        const users = new Set();
        
        if (result.item.messages && typeof result.item.messages === 'object') {
          companies.add(result.item.compName || result.item.id);
          Object.entries(result.item.messages).forEach(([storeId, storeData]) => {
            if (storeData.userName) {
              users.add(storeData.userName);
            }
            if (storeData.messages && Array.isArray(storeData.messages)) {
              storeData.messages.forEach(category => {
                if (category.messages && Array.isArray(category.messages)) {
                  category.messages.forEach(request => {
                    allRequests.push({
                      ...request,
                      type: category.category === 'sendbak' ? 'センドバック' : 'サポート',
                      category: category.category,
                      storeId: storeId,
                      companyId: result.item.id,
                      companyName: result.item.compName || result.item.id, // 企業名を追加
                      userName: storeData.userName || '-' // ユーザー名を追加
                    });
                  });
                }
              });
            }
          });
        }

        console.log('Admin single companies:', Array.from(companies));
        console.log('Admin single users:', Array.from(users));
        console.log('Admin single allRequests:', allRequests);
        
        // タイムスタンプで降順ソート（新しい順）
        allRequests.sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));
        
        setAllRequests(allRequests);
        setAvailableCompanies(Array.from(companies).sort());
        setAvailableUsers(Array.from(users).sort());
        setRequests(allRequests);
        
      } else if (result && result.item && result.item.messages) {
        // HQ/Store権限の場合の処理
        const allRequests = [];
        const users = new Set();

        console.log('HQ/Store processing result.item:', result.item);

        Object.entries(result.item.messages).forEach(([storeId, storeData]) => {
          if (storeData.userName) {
            users.add(storeData.userName);
          }
          if (storeData.messages && Array.isArray(storeData.messages)) {
            storeData.messages.forEach(category => {
              if (category.messages && Array.isArray(category.messages)) {
                category.messages.forEach(request => {
                  allRequests.push({
                    ...request,
                    type: category.category === 'sendbak' ? 'センドバック' : 'サポート',
                    category: category.category,
                    storeId: storeId,
                    companyName: result.item.compName || result.item.id, // 企業名を追加
                    userName: storeData.userName || '-' // ユーザー名を追加
                  });
                });
              }
            });
          }
        });
        
        console.log('HQ/Store users:', Array.from(users));
        console.log('HQ/Store allRequests:', allRequests);
        
        // 権限による絞り込み
        let filteredRequests = allRequests;
        if (loginInfo.authorityId === 'store') {
          // 店舗ユーザーは自分の店舗のデータのみ
          filteredRequests = allRequests.filter(request => request.storeId === loginInfo.userId);
        }
        // HQは同じ企業の全店舗データを表示
        
        // タイムスタンプで降順ソート（新しい順）
        filteredRequests.sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));
        
        setAllRequests(filteredRequests);
        setAvailableUsers(Array.from(users).sort());
        setRequests(filteredRequests);
      } else {
        console.log('No data found or unexpected format:', result);
        setAllRequests([]);
        setRequests([]);
      }
    } catch (error) {
      console.error('依頼進捗データの取得エラー:', error);
      setAllRequests([]);
      setRequests([]);
    } finally {
      setLoading(false);
    }
  };

  // フィルターを適用する関数
  const applyFilters = () => {
    let filteredRequests = [...allRequests];

    console.log('Applying filters - companyFilter:', companyFilter, 'userFilter:', userFilter, 'searchText:', searchText, 'statusFilter:', statusFilter, 'dateFrom:', dateFrom, 'dateTo:', dateTo);
    console.log('Available companies:', availableCompanies);
    console.log('Available users:', availableUsers);

    // 企業名フィルター（Admin権限のみ）
    if (loginInfo.authorityId === 'admin' && companyFilter) {
      filteredRequests = filteredRequests.filter(request => request.companyName === companyFilter);
      console.log('After company filter:', filteredRequests.length);
    }

    // ユーザー名フィルター
    if (userFilter) {
      filteredRequests = filteredRequests.filter(request => request.userName === userFilter);
      console.log('After user filter:', filteredRequests.length);
    }

    // 文言検索フィルター
    if (searchText && searchText.trim() !== '') {
      const searchLower = searchText.toLowerCase();
      filteredRequests = filteredRequests.filter(request => {
        const content = (request.content || request.text || '').toLowerCase();
        const requestNumber = (request.requestNumber || '').toLowerCase();
        const actionNumber = (request.actionNumber || '').toLowerCase();
        return content.includes(searchLower) || 
               requestNumber.includes(searchLower) || 
               actionNumber.includes(searchLower);
      });
      console.log('After search filter:', filteredRequests.length);
    }

    // 日付Fromフィルター
    if (dateFrom) {
      const fromTimestamp = new Date(dateFrom).setHours(0, 0, 0, 0); // 当日の0時
      filteredRequests = filteredRequests.filter(request => {
        const requestTimestamp = request.timestamp || 0;
        return requestTimestamp >= fromTimestamp;
      });
      console.log('After dateFrom filter:', filteredRequests.length);
    }

    // 日付Toフィルター
    if (dateTo) {
      const toTimestamp = new Date(dateTo).setHours(23, 59, 59, 999); // 当日の23時59分59秒
      filteredRequests = filteredRequests.filter(request => {
        const requestTimestamp = request.timestamp || 0;
        return requestTimestamp <= toTimestamp;
      });
      console.log('After dateTo filter:', filteredRequests.length);
    }

    // 状態フィルター
    if (statusFilter) {
      filteredRequests = filteredRequests.filter(request => {
        const displayStatus = reqActionStatuses[request.requestNumber] || '依頼中';
        return displayStatus === statusFilter;
      });
      console.log('After status filter:', filteredRequests.length);
    }

    // サイドバーの状態フィルター（既存の機能を維持）
    if (requestStatusFilter) {
      filteredRequests = filteredRequests.filter(request => {
        // con-concierge-reqactionからステータスを取得（存在しなければデフォルト「依頼中」）
        const displayStatus = reqActionStatuses[request.requestNumber] || '依頼中';
        return displayStatus === requestStatusFilter;
      });
    }

    // ソートを適用
    const sortedRequests = applySorting(filteredRequests);
    setRequests(sortedRequests);
  };

  // allRequestsが変わったら状態ごとの件数を計算
  useEffect(() => {
    const counts = {};
    allRequests.forEach(request => {
      // con-concierge-reqactionからステータスを取得（存在しなければデフォルト「依頼中」）
      const status = reqActionStatuses[request.requestNumber] || '依頼中';
      counts[status] = (counts[status] || 0) + 1;
    });
    setRequestStatusCounts(counts);

    // 未読コメント数と未読依頼数を計算
    const unreadCount = allRequests.reduce((total, request) => {
      // 未読コメント数を計算
      const requestUnreadCount = (request.comments || []).filter(comment => 
        comment.unreadFor && comment.unreadFor.includes(loginInfo.authorityId)
      ).length;
      
      // 未読依頼かどうかをチェック（依頼自体が未読の場合）
      const isUnreadRequest = (request.unreadFor && request.unreadFor.includes(loginInfo.authorityId)) ? 1 : 0;
      
      return total + requestUnreadCount + isUnreadRequest;
    }, 0);
    setUnreadCommentCount(unreadCount);
  }, [allRequests, reqActionStatuses, loginInfo.authorityId, setUnreadCommentCount]);

  // フィルターをクリアする関数
  const clearFilters = () => {
    setCompanyFilter('');
    setUserFilter('');
    setSearchText('');
    setStatusFilter('');
    setDateFrom(getDefaultDateFrom()); // デフォルト値に戻す
    setDateTo(getDefaultDateTo()); // デフォルト値に戻す
    setRequestStatusFilter('');
    setRequests(allRequests);
  };

  // ソート処理（フィルター適用後に実行）
  const applySorting = (requestsToSort) => {
    return [...requestsToSort].sort((a, b) => {
      let aValue, bValue;
      
      switch (sortField) {
        case 'timestamp':
          aValue = a.timestamp || 0;
          bValue = b.timestamp || 0;
          break;
        case 'companyName':
          aValue = (a.companyName || '').toLowerCase();
          bValue = (b.companyName || '').toLowerCase();
          break;
        case 'status':
          aValue = (a.status || '').toLowerCase();
          bValue = (b.status || '').toLowerCase();
          break;
        default:
          return 0;
      }
      
      if (sortOrder === 'asc') {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      } else {
        return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
      }
    });
  };

  // ソート処理とフィルター・ソート状態の変更を監視
  useEffect(() => {
    if (allRequests.length > 0) {
      applyFilters();
    }
  }, [companyFilter, userFilter, searchText, statusFilter, dateFrom, dateTo, allRequests, sortField, sortOrder, requestStatusFilter, reqActionStatuses]);

  // ソート処理
  const handleSort = (field) => {
    if (sortField === field) {
      // 同じフィールドをクリックした場合は昇順/降順を切り替え
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      // 異なるフィールドをクリックした場合は新しいフィールドで昇順
      setSortField(field);
      setSortOrder('asc');
    }
  };

  // ソートアイコンを取得
  const getSortIcon = (field) => {
    if (sortField !== field) {
      return null; // ソート対象でない場合はアイコンなし
    }
    return sortOrder === 'asc' ? <ArrowUpward fontSize="small" /> : <ArrowDownward fontSize="small" />;
  };

  // 参照ボタンクリック時の処理
  const handleViewRequest = async (request) => {
    setSelectedRequest(request);
    setEditedContent(request.content || '');
    
    // con-concierge-reqactionからステータスを取得（存在しなければデフォルト「依頼中」）
    const displayStatus = reqActionStatuses[request.requestNumber] || '依頼中';
    setEditedStatus(displayStatus);
    
    setEditedActionNumber(request.actionNumber || ''); // アクション番号を設定
    setComments(request.comments || []); // コメントを設定
    setNewComment(''); // 新規コメントをクリア
    setModalOpen(true);

    // 未読コメントと未読依頼を一度に既読にする
    await markAsRead(request);
  };

  // モーダルを閉じる処理
  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedRequest(null);
    setEditedContent('');
    setEditedStatus('');
    setEditedActionNumber(''); // アクション番号をクリア
    setComments([]);
    setNewComment('');
  };

  // コメントを追加する処理
  const handleAddComment = async () => {
    if (!newComment.trim() || !selectedRequest) return;

    try {
      // 未読対象ユーザーを決定
      let unreadFor = [];
      if (loginInfo.authorityId === 'admin') {
        // 管理者がコメント → 本部・店舗が未読対象
        unreadFor = ['HQ', 'store'];
      } else {
        // 本部・店舗がコメント → 管理者が未読対象
        unreadFor = ['admin'];
      }

      const comment = {
        id: crypto.randomUUID(),
        text: newComment,
        userName: loginInfo.userName,
        userId: loginInfo.userId,
        authorityId: loginInfo.authorityId,
        timestamp: Date.now(),
        unreadFor: unreadFor // 未読対象の権限リスト
      };

      const updatedComments = [...comments, comment];
      setComments(updatedComments);
      setNewComment('');

      // CosmosDBに保存
      const userId = loginInfo.authorityId === 'admin' ? selectedRequest.companyId : loginInfo.compId;
      
      const loadPayload = { 
        id: userId, 
        container: 'con-concierge-request' 
      };
      
      const existingData = await LoadToCosmos(loadPayload);
      if (existingData && existingData.item && existingData.item.messages) {
        const storesData = existingData.item.messages;
        
        // 該当する依頼を検索してコメントを更新
        Object.keys(storesData).forEach(storeId => {
          storesData[storeId].messages.forEach(category => {
            const requestIndex = category.messages.findIndex(req => req.id === selectedRequest.id);
            if (requestIndex !== -1) {
              category.messages[requestIndex].comments = updatedComments;
              category.messages[requestIndex].updatedAt = Date.now();
            }
          });
        });

        // CosmosDBに保存
        const savePayload = {
          id: userId,
          compName: loginInfo.authorityId === 'admin' ? selectedRequest.companyName : loginInfo.compName,
          messages: storesData,
          container: "con-concierge-request"
        };
        
        await SendToCosmos(savePayload);
        
        // データを再取得して最新の状態を反映
        await fetchRequests();
      }

      // Webhookに送信（コメント追加を通知）
      await sendCommentToWebhook(comment.text, selectedRequest.requestID, selectedRequest.requestNumber);

    } catch (error) {
      console.error('コメント追加エラー:', error);
      alert('コメントの追加に失敗しました。');
    }
  };

  // コメントと依頼を既読にする処理（統合版）
  const markAsRead = async (request) => {
    try {
      // 未読コメントと未読依頼の両方をチェック
      const hasUnreadComments = (request.comments || []).some(comment => 
        comment.unreadFor && comment.unreadFor.includes(loginInfo.authorityId)
      );
      const isUnreadRequest = request.unreadFor && request.unreadFor.includes(loginInfo.authorityId);

      // どちらも未読でなければ何もしない
      if (!hasUnreadComments && !isUnreadRequest) {
        return;
      }

      console.log('=== 既読処理開始 ===');
      console.log('未読コメント:', hasUnreadComments);
      console.log('未読依頼:', isUnreadRequest);

      // CosmosDBからデータを取得
      const userId = loginInfo.authorityId === 'admin' ? request.companyId : loginInfo.compId;
      
      const loadPayload = { 
        id: userId, 
        container: 'con-concierge-request' 
      };
      
      const existingData = await LoadToCosmos(loadPayload);
      if (existingData && existingData.item && existingData.item.messages) {
        const storesData = existingData.item.messages;
        
        // 該当する依頼を検索して未読フラグをクリア
        let updated = false;
        Object.keys(storesData).forEach(storeId => {
          storesData[storeId].messages.forEach(category => {
            const requestIndex = category.messages.findIndex(req => req.id === request.id);
            if (requestIndex !== -1) {
              // コメントの未読フラグをクリア
              if (hasUnreadComments && category.messages[requestIndex].comments) {
                category.messages[requestIndex].comments = category.messages[requestIndex].comments.map(comment => {
                  if (comment.unreadFor && comment.unreadFor.includes(loginInfo.authorityId)) {
                    return {
                      ...comment,
                      unreadFor: comment.unreadFor.filter(auth => auth !== loginInfo.authorityId)
                    };
                  }
                  return comment;
                });
                updated = true;
              }
              
              // 依頼の未読フラグをクリア
              if (isUnreadRequest && category.messages[requestIndex].unreadFor) {
                category.messages[requestIndex].unreadFor = category.messages[requestIndex].unreadFor.filter(
                  auth => auth !== loginInfo.authorityId
                );
                updated = true;
              }
            }
          });
        });

        if (updated) {
          console.log('=== CosmosDBに保存 ===');
          // CosmosDBに保存（1回で両方の変更を保存）
          const savePayload = {
            id: userId,
            compName: loginInfo.authorityId === 'admin' ? request.companyName : loginInfo.compName,
            messages: storesData,
            container: "con-concierge-request"
          };
          
          await SendToCosmos(savePayload);
          
          // データを再取得して最新の状態を反映
          await fetchRequests();
          console.log('=== 既読処理完了 ===');
        }
      }
    } catch (error) {
      console.error('既読処理エラー:', error);
    }
  };

  // コメントをWebhookに送信する関数
  const sendCommentToWebhook = async (commentText, requestID, requestNumber) => {
    try {
      // webhookが存在するかチェック
      const webhook = (loginInfo?.webhook && typeof loginInfo.webhook === 'object' && loginInfo.webhook !== 'none')
        ? loginInfo.webhook?.support?.url
        : null;

      if (!webhook) {
        console.log('Webhook URLが設定されていないため、コメント通知をスキップします');
        return;
      }

      const header = {'Content-Type': 'application/json'};
      
      const message = {
        attachments: [
          {
            contentType: "application/vnd.microsoft.card.hero",
            content: {
              title: "コメント追加",
              text: commentText,
              requestID: requestID || '',
              requestNumber: requestNumber || ''
            }
          }
        ]
      };

      const requestBody = {
        api: webhook,
        header: header, 
        message: message,
        mode: 'supportsend',
      };

      console.log('=== Teams Webhook コメント送信情報 ===');
      console.log('Webhook URL:', webhook);
      console.log('Request Body:', JSON.stringify(requestBody, null, 2));
      console.log('======================================');

      const response = await fetch(`${process.env.REACT_APP_CROSPRO_URL}?code=${process.env.REACT_APP_CROSPRO_KEY}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestBody),
      });

      console.log('Webhook送信レスポンス:', response.status, response.statusText);

      if (response.status !== 200) {
        console.error('Webhook送信エラー:', response.status, response.statusText);
      }

    } catch (error) {
      console.error('Webhook送信エラー:', error);
      // エラーが発生してもコメント追加自体は成功しているので、ユーザーには通知しない
    }
  };

  // 依頼内容を保存する処理（Admin権限のみステータスとアクション番号を編集可能）
  const handleSaveRequest = async () => {
    if (!selectedRequest) return;

    // Admin以外は編集不可
    if (loginInfo.authorityId !== 'admin') {
      alert('ステータスとアクション番号の編集は管理者権限が必要です。');
      return;
    }

    try {
      setSaving(true);
      console.log('=== 保存処理開始 ===');
      console.log('selectedRequest:', selectedRequest);
      console.log('editedStatus:', editedStatus);
      console.log('editedActionNumber:', editedActionNumber);
      console.log('==================');
      
      // ステータスまたはアクション番号が変更された場合は更新
      if (editedStatus !== selectedRequest.status || editedActionNumber !== (selectedRequest.actionNumber || '')) {
        await updateRequestStatus(selectedRequest, editedStatus, loginInfo, editedActionNumber);
        
        // アクション番号が入力されている場合はcon-concierge-reqactionにも保存（新規・上書き共通）
        if (editedActionNumber && editedActionNumber.trim() !== '') {
          await saveToReqActionContainer(editedActionNumber, selectedRequest);
        }
      }

      // データを再取得
      await fetchRequests();
      await fetchReqActionStatuses(); // ステータスマップも再取得
      
      handleCloseModal();
    } catch (error) {
      console.error('依頼の更新エラー:', error);
      alert('更新に失敗しました。');
    } finally {
      setSaving(false);
    }
  };

  // con-concierge-reqactionコンテナに保存する関数（新規・上書き共通）
  const saveToReqActionContainer = async (actionNumber, request) => {
    try {
      // CosmosDBに保存するデータ（新規でも上書きでも同じ完全な情報を送信）
      // id: requestNumberの値、actionno: アクション番号の値
      const savePayload = {
        container: "con-concierge-reqaction",
        id: request.requestNumber,        // requestNumberの値をidに設定
        actionno: actionNumber,            // アクション番号をactionnoに設定
        status: editedStatus,
        storeId: request.storeId,
        companyId: request.companyId || loginInfo.compId,
        companyName: request.companyName || loginInfo.compName,
        userName: request.userName || loginInfo.userName,
        content: request.content || request.text || '',
        category: request.category || 'support',
        requestID: request.requestID || '',
        timestamp: request.timestamp || Date.now(),
        updatedAt: Date.now(),
        updatedBy: loginInfo.userId,
        updatedByName: loginInfo.userName
      };

      console.log('=== con-concierge-reqaction保存データ（新規・上書き共通） ===');
      console.log('保存データ:', JSON.stringify(savePayload, null, 2));
      console.log('データ項目数:', Object.keys(savePayload).length);
      console.log('========================================================');
      
      await SendToCosmos(savePayload);
      console.log('✓ con-concierge-reqactionに保存完了');
      
    } catch (error) {
      console.error('✗ con-concierge-reqaction保存エラー:', error);
      throw error;
    }
  };

  // ステータスオプション
  const statusOptions = [
    '依頼中',
    '受取',
    '派遣中',
    '移動中', 
    '作業中',
    '完了',
    'キャンセル'
  ];

  useEffect(() => {
    const loadData = async () => {
      await fetchRequests();
      await fetchReqActionStatuses();
    };
    loadData();
  }, []);

  // ステータスに応じたアイコンと色を返す
//AssignmentTurnedIn　受取
//Engineering　作業中
//DirectionsCar　移動中
  const getStatusIcon = (status) => {
    switch (status) {
      case '依頼中':
        return { icon: <Autorenew />, color: 'default' };
      case '受取':
        return { icon: <AssignmentTurnedIn />, color: 'primary' };
      case '派遣中':
        return { icon: <SupportAgent />, color: 'info' };
      case '移動中':
        return { icon: <DirectionsCar />, color: 'primary' };
      case '作業中':
        return { icon: <Engineering />, color: 'primary' };
      case '完了':
        return { icon: <CompleteIcon />, color: 'success' };
      case 'キャンセル':
        return { icon: <CancelIcon />, color: 'error' };
      default:
        return { icon: <ScheduleIcon />, color: 'default' };
    }
  };

  // 依頼種別に応じたアイコンと色を返す
  const getTypeIcon = (category) => {
    switch (category) {
      case 'sendbak':
        return { icon: <SendbackIcon />, color: 'warning', label: '部品注文' };
      case 'support':
      default:
        return { icon: <SupportAgent />, color: 'primary', label: 'サポート' };
    }
  };

  // 日付フォーマット
  const formatDate = (timestamp) => {
    if (!timestamp) return '-';
    const date = new Date(timestamp);
    return date.toLocaleString('ja-JP');
  };

  if (loading) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100%' 
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // CSV出力関数
  const exportToCSV = () => {
    if (requests.length === 0) {
      alert('エクスポートするデータがありません。');
      return;
    }

    // CSVヘッダー
    const headers = [
      '依頼日時',
      loginInfo.authorityId === 'admin' ? '企業名' : null,
      '依頼者',
      '店名',
      '種別',
      '受付番号',
      '内容',
      'アクション番号',
      '状態'
    ].filter(Boolean); // nullを除去

    // CSVデータ行を作成
    const csvRows = requests.map(request => {
      const displayStatus = reqActionStatuses[request.requestNumber] || '依頼中';
      const typeLabel = request.category === 'sendbak' ? '部品注文' : 'サポート';
      const content = (request.content || request.text || '-')
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<[^>]*>/g, '')
        .replace(/"/g, '""'); // ダブルクォートをエスケープ

      const row = [
        formatDate(request.timestamp),
        loginInfo.authorityId === 'admin' ? (request.companyName || '-') : null,
        request.userName || '-',
        request.storeName || '-',
        typeLabel,
        request.requestNumber || '-',
        `"${content}"`, // 内容はダブルクォートで囲む
        request.actionNumber || '-',
        displayStatus
      ].filter(item => item !== null); // nullを除去

      return row;
    });

    // CSV文字列を作成
    const csvContent = [
      headers.join(','),
      ...csvRows.map(row => row.join(','))
    ].join('\r\n');

    // BOMを追加（Excelで文字化けを防ぐため）
    const bom = '\uFEFF';
    const blob = new Blob([bom + csvContent], { type: 'text/csv;charset=utf-8;' });

    // ファイル名を生成（日時付き）
    const now = new Date();
    const filename = `依頼進捗一覧_${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}_${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}.csv`;

    // ダウンロード
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  };

  return (
    <Box sx={{ p: 1.5, height: '100%', overflow: 'auto' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6" component="h1" sx={{ color: '#1976d2' }}>
          依頼進捗一覧
        </Typography>
        <Button 
          variant="contained" 
          size="small" 
          onClick={exportToCSV}
          disabled={requests.length === 0}
          sx={{ fontSize: '0.75rem', py: 0.5, px: 1.5 }}
        >
          CSV出力
        </Button>
      </Box>

      {/* フィルター部分 */}
      {(loginInfo.authorityId === 'admin' || loginInfo.authorityId === 'HQ') && (
        <Paper sx={{ p: 1.5, mb: 1.5 }}>
          <Grid container spacing={1} alignItems="center">
            {/* 日付From */}
            <Grid item sm={1.3}>
              <TextField
                fullWidth
                size="small"
                type="date"
                label="依頼日From"
                value={dateFrom}
                onChange={(e) => setDateFrom(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                  sx: { fontSize: '0.7rem' }
                }}
                sx={{ 
                  '& .MuiInputBase-input': { fontSize: '0.7rem', py: 0.9 }
                }}
              />
            </Grid>
            
            {/* 日付To */}
            <Grid item sm={1.3}>
              <TextField
                fullWidth
                size="small"
                type="date"
                label="依頼日To"
                value={dateTo}
                onChange={(e) => setDateTo(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                  sx: { fontSize: '0.7rem' }
                }}
                sx={{ 
                  '& .MuiInputBase-input': { fontSize: '0.7rem', py: 0.9 }
                }}
              />
            </Grid>

            {/* 企業名フィルター（Admin権限のみ） */}
            {loginInfo.authorityId === 'admin' && (
              <Grid item sm={1.8}>
                <FormControl fullWidth size="small">
                  <InputLabel sx={{ fontSize: '0.7rem' }}>企業名</InputLabel>
                  <Select
                    value={companyFilter}
                    label="企業名"
                    onChange={(e) => setCompanyFilter(e.target.value)}
                    sx={{ fontSize: '0.7rem', '& .MuiSelect-select': { py: 0.9 } }}
                  >
                    <MenuItem value="" sx={{ fontSize: '0.7rem' }}>全て</MenuItem>
                    {availableCompanies.map((companyName) => (
                      <MenuItem key={companyName} value={companyName} sx={{ fontSize: '0.7rem' }}>
                        {companyName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}
            
            {/* ユーザー名フィルター */}
            <Grid item sm={loginInfo.authorityId === 'admin' ? 1.8 : 2.3}>
              <FormControl fullWidth size="small">
                <InputLabel sx={{ fontSize: '0.7rem' }}>依頼者</InputLabel>
                <Select
                  value={userFilter}
                  label="依頼者"
                  onChange={(e) => setUserFilter(e.target.value)}
                  sx={{ fontSize: '0.7rem', '& .MuiSelect-select': { py: 0.9 } }}
                >
                  <MenuItem value="" sx={{ fontSize: '0.7rem' }}>全て</MenuItem>
                  {availableUsers.map((userName) => (
                    <MenuItem key={userName} value={userName} sx={{ fontSize: '0.7rem' }}>
                      {userName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            
            {/* 文言検索フィルター */}
            <Grid item sm={loginInfo.authorityId === 'admin' ? 2.8 : 3.3}>
              <TextField
                fullWidth
                size="small"
                label="文言で検索"
                placeholder="依頼内容、受付番号、アクション番号"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                sx={{ 
                  '& .MuiInputLabel-root': { fontSize: '0.7rem' },
                  '& .MuiInputBase-input': { fontSize: '0.7rem', py: 0.9 }
                }}
              />
            </Grid>
            
            {/* 状態フィルター */}
            <Grid item sm={loginInfo.authorityId === 'admin' ? 1.2 : 1.5}>
              <FormControl fullWidth size="small">
                <InputLabel sx={{ fontSize: '0.7rem' }}>状態</InputLabel>
                <Select
                  value={statusFilter}
                  label="状態"
                  onChange={(e) => setStatusFilter(e.target.value)}
                  sx={{ fontSize: '0.7rem', '& .MuiSelect-select': { py: 0.9 } }}
                >
                  <MenuItem value="" sx={{ fontSize: '0.7rem' }}>全て</MenuItem>
                  {statusOptions.map((status) => (
                    <MenuItem key={status} value={status} sx={{ fontSize: '0.7rem' }}>
                      {status}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            
            {/* クリアボタン */}
            <Grid item sm={loginInfo.authorityId === 'admin' ? 0.8 : 1.3}>
              <Button 
                variant="outlined" 
                size="small" 
                onClick={clearFilters}
                disabled={!companyFilter && !userFilter && !searchText && !statusFilter && dateFrom === getDefaultDateFrom() && dateTo === getDefaultDateTo()}
                sx={{ fontSize: '0.65rem', py: 0.75, px: 0.5, width: '100%', minWidth: 'auto' }}
              >
                クリア
              </Button>
            </Grid>
          </Grid>
        </Paper>
      )}

      <Box sx={{ mb: 1.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.8rem' }}>
          全 {requests.length} 件の依頼
          {allRequests.length !== requests.length && (
            <span> （{allRequests.length} 件中）</span>
          )}
        </Typography>
        <Button 
          variant="outlined" 
          size="small" 
          onClick={async () => {
            await fetchRequests();
            await fetchReqActionStatuses();
          }}
          sx={{ fontSize: '0.75rem', py: 0.5, px: 1 }}
        >
          更新
        </Button>
      </Box>

      {requests.length === 0 ? (
        <Box 
          sx={{ 
            textAlign: 'center', 
            py: 3,
            color: 'text.secondary' 
          }}
        >
          <Typography variant="body1">
            依頼履歴がありません
          </Typography>
        </Box>
      ) : (
        <TableContainer component={Paper} sx={{ maxHeight: 'calc(100vh - 180px)' }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell 
                  sx={{ 
                    fontSize: '0.8rem', 
                    py: 1, 
                    cursor: 'pointer',
                    userSelect: 'none',
                    '&:hover': { backgroundColor: '#f5f5f5' },
                    width: '130px'
                  }}
                  onClick={() => handleSort('timestamp')}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    依頼日時
                    {getSortIcon('timestamp')}
                  </Box>
                </TableCell>
                {loginInfo.authorityId === 'admin' && (
                  <TableCell 
                    sx={{ 
                      fontSize: '0.8rem', 
                      py: 1, 
                      cursor: 'pointer',
                      userSelect: 'none',
                      '&:hover': { backgroundColor: '#f5f5f5' },
                      width: '150px'
                    }}
                    onClick={() => handleSort('companyName')}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      企業名
                      {getSortIcon('companyName')}
                    </Box>
                  </TableCell>
                )}
                <TableCell sx={{ fontSize: '0.8rem', py: 1, width: '150px' }}>依頼者</TableCell>
                <TableCell sx={{ fontSize: '0.8rem', py: 1, width: '150px' }}>店名</TableCell>
                <TableCell sx={{ fontSize: '0.8rem', py: 1, width: '40px', textAlign: 'center' }}>種別</TableCell>
                <TableCell sx={{ fontSize: '0.8rem', py: 1 }}>内容</TableCell>
                <TableCell sx={{ fontSize: '0.8rem', py: 1, width: '110px' }}>アクション番号</TableCell>
                <TableCell 
                  sx={{ 
                    fontSize: '0.8rem', 
                    py: 1, 
                    cursor: 'pointer',
                    userSelect: 'none',
                    '&:hover': { backgroundColor: '#f5f5f5' },
                    width: '90px'
                  }}
                  onClick={() => handleSort('status')}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    状態
                    {getSortIcon('status')}
                  </Box>
                </TableCell>
                <TableCell sx={{ fontSize: '0.8rem', py: 1, width: '50px' }}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {requests.map((request, index) => (
                <TableRow key={`${request.id || 'req'}-${index}`} hover>
                  <TableCell sx={{ fontSize: '0.75rem', py: 0.5, width: '130px' }}>
                    {formatDate(request.timestamp)}
                  </TableCell>
                  {loginInfo.authorityId === 'admin' && (
                    <TableCell sx={{ fontSize: '0.75rem', py: 0.5, width: '150px' }}>
                      <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.75rem' }}>
                        {request.companyName || '-'}
                      </Typography>
                    </TableCell>
                  )}
                  <TableCell sx={{ fontSize: '0.75rem', py: 0.5, width: '150px' }}>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.75rem' }}>
                      {request.userName || '-'}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ fontSize: '0.75rem', py: 0.5, width: '150px' }}>
                    <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.75rem' }}>
                      {request.storeName || '-'}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ fontSize: '0.75rem', py: 0.5, width: '40px', textAlign: 'center' }}>
                    {(() => {
                      const typeInfo = getTypeIcon(request.category);
                      const iconColor = request.category === 'sendbak' ? '#4caf50' : '#1976d2'; // センドバック: 緑、サポート: 青
                      const tooltipTitle = request.category === 'sendbak' ? 'センドバック' : 'サポート';
                      return (
                        <Tooltip title={tooltipTitle} arrow>
                          <span>
                            {React.cloneElement(typeInfo.icon, { style: { color: iconColor, fontSize: '1.2rem' } })}
                          </span>
                        </Tooltip>
                      );
                    })()}
                  </TableCell>
                  <TableCell sx={{ fontSize: '0.75rem', py: 0.5 }}>
                    <div
                      style={{ 
                        overflow: 'hidden',
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                        fontSize: '0.75rem',
                        lineHeight: '1.4'
                      }}
                      title={(request.content || request.text || '-')
                        .replace(/<br\s*\/?>/gi, '\n')
                        .replace(/<[^>]*>/g, '')
                      }
                      dangerouslySetInnerHTML={{ 
                        __html: (request.content || request.text || '-')
                          .replace(/\n/g, '<br>')
                          .replace(/\\n/g, '<br>')
                      }}
                    />
                  </TableCell>
                  <TableCell sx={{ fontSize: '0.75rem', py: 0.5, width: '110px' }}>
                    {request.actionNumber ? (
                      <a
                        href={`https://fsv.975194.jp/fsv/attachments/show_by_action_no?actionno=${request.actionNumber}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          fontFamily: 'monospace',
                          fontSize: '0.75rem',
                          color: '#1976d2',
                          textDecoration: 'underline',
                          cursor: 'pointer'
                        }}
                      >
                        {request.actionNumber}
                      </a>
                    ) : (
                      <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.75rem' }}>
                        -
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell sx={{ fontSize: '0.75rem', py: 0.5, width: '90px' }}>
                    {(() => {
                      // con-concierge-reqactionからステータスを取得（存在しなければデフォルト「依頼中」）
                      const displayStatus = reqActionStatuses[request.requestNumber] || '依頼中';
                      const statusInfo = getStatusIcon(displayStatus);
                      return (
                        <Chip 
                          icon={statusInfo.icon}
                          label={displayStatus} 
                          size="small" 
                          color={statusInfo.color}
                          sx={{ fontSize: '0.7rem', height: '20px' }}
                        />
                      );
                    })()}
                  </TableCell>
                  <TableCell sx={{ fontSize: '0.75rem', py: 0.5, width: '50px' }}>
                    <IconButton
                      size="small"
                      onClick={() => handleViewRequest(request)}
                      sx={{ fontSize: '0.7rem' }}
                      title="編集"
                    >
                      <Badge 
                        badgeContent={(() => {
                          // 未読コメント数を計算
                          const unreadCommentsCount = (request.comments || []).filter(comment => 
                            comment.unreadFor && comment.unreadFor.includes(loginInfo.authorityId)
                          ).length;
                          
                          // 依頼自体が未読かチェック
                          const isUnreadRequest = (request.unreadFor && request.unreadFor.includes(loginInfo.authorityId)) ? 1 : 0;
                          
                          // 合計を返す
                          return unreadCommentsCount + isUnreadRequest;
                        })()}
                        color="error"
                        sx={{
                          '& .MuiBadge-badge': {
                            fontSize: '0.6rem',
                            height: '16px',
                            minWidth: '16px',
                            padding: '0 4px'
                          }
                        }}
                      >
                        <EditIcon fontSize="small" />
                      </Badge>
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* 編集モーダル */}
      <Dialog 
        open={modalOpen} 
        onClose={handleCloseModal}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          依頼編集
          {selectedRequest && (
            <Typography variant="body2" color="text.secondary">
              受付番号: {selectedRequest.requestNumber}
            </Typography>
          )}
        </DialogTitle>
        <DialogContent>
          {selectedRequest && (
            <Box sx={{ mt: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">依頼日時</Typography>
                  <Typography variant="body1">{formatDate(selectedRequest.timestamp)}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">依頼種別</Typography>
                  <Typography variant="body1">{selectedRequest.type}</Typography>
                </Grid>
                {loginInfo.authorityId === 'admin' && (
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body2" color="text.secondary">企業名</Typography>
                    <Typography variant="body1">{selectedRequest.companyName || '-'}</Typography>
                  </Grid>
                )}
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">依頼者</Typography>
                  <Typography variant="body1">{selectedRequest.userName || '-'}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary">店名</Typography>
                  <Typography variant="body1">{selectedRequest.storeName || '-'}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>依頼内容</Typography>
                  <Paper sx={{ p: 2, backgroundColor: '#f5f5f5' }}>
                    <div 
                      style={{ whiteSpace: 'pre-wrap' }}
                      dangerouslySetInnerHTML={{ 
                        __html: (editedContent || '-')
                          .replace(/\n/g, '<br>')
                          .replace(/\\n/g, '<br>')
                      }} 
                    />
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>ステータス</Typography>
                  {loginInfo.authorityId === 'admin' ? (
                    <FormControl fullWidth>
                      <Select
                        value={editedStatus}
                        onChange={(e) => setEditedStatus(e.target.value)}
                        size="small"
                      >
                        {statusOptions.map((status) => (
                          <MenuItem key={status} value={status}>
                            {status}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  ) : (
                    <Chip 
                      icon={getStatusIcon(selectedRequest.status).icon}
                      label={selectedRequest.status || '依頼中'} 
                      size="small" 
                      color={getStatusIcon(selectedRequest.status).color}
                    />
                  )}
                </Grid>
                {/* アクション番号 */}
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>アクション番号</Typography>
                  {loginInfo.authorityId === 'admin' ? (
                    <TextField
                      fullWidth
                      size="small"
                      value={editedActionNumber}
                      onChange={(e) => setEditedActionNumber(e.target.value)}
                      placeholder="アクション番号を入力"
                      variant="outlined"
                    />
                  ) : (
                    <Typography variant="body1">
                      {selectedRequest.actionNumber || '-'}
                    </Typography>
                  )}
                </Grid>
                {/* コメントセクション */}
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, mt: 2 }}>
                    <Typography variant="body2" color="text.secondary">コメント</Typography>
                    {comments.filter(comment => 
                      comment.unreadFor && comment.unreadFor.includes(loginInfo.authorityId)
                    ).length > 0 && (
                      <Badge 
                        badgeContent={
                          comments.filter(comment => 
                            comment.unreadFor && comment.unreadFor.includes(loginInfo.authorityId)
                          ).length
                        }
                        color="error"
                        sx={{
                          '& .MuiBadge-badge': {
                            fontSize: '0.7rem',
                            height: '18px',
                            minWidth: '18px',
                            padding: '0 5px'
                          }
                        }}
                      >
                        <Box sx={{ width: 10 }} />
                      </Badge>
                    )}
                  </Box>
                  
                  {/* コメント一覧 */}
                  <Paper sx={{ p: 2, mb: 2, maxHeight: 300, overflow: 'auto', backgroundColor: '#fafafa' }}>
                    {comments.length === 0 ? (
                      <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 2 }}>
                        コメントはありません
                      </Typography>
                    ) : (
                      comments.map((comment) => {
                        const isUnread = comment.unreadFor && comment.unreadFor.includes(loginInfo.authorityId);
                        return (
                          <Box 
                            key={comment.id} 
                            sx={{ 
                              mb: 2, 
                              pb: 1.5,
                              borderBottom: '1px solid #e0e0e0',
                              '&:last-child': { borderBottom: 'none', mb: 0 },
                              backgroundColor: isUnread ? '#fff3e0' : 'transparent', // 未読は薄いオレンジ背景
                              p: 1.5,
                              borderRadius: 1
                            }}
                          >
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Badge 
                                  variant="dot"
                                  color="error"
                                  invisible={!isUnread}
                                  sx={{
                                    '& .MuiBadge-badge': {
                                      right: -3,
                                      top: 3
                                    }
                                  }}
                                >
                                  <Chip 
                                    label={comment.userName} 
                                    size="small" 
                                    color={comment.authorityId === 'admin' ? 'error' : comment.authorityId === 'HQ' ? 'primary' : 'default'}
                                    sx={{ fontSize: '0.7rem', height: '20px' }}
                                  />
                                </Badge>
                                <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                                  {formatDate(comment.timestamp)}
                                </Typography>
                                {isUnread && (
                                  <Chip 
                                    label="NEW" 
                                    size="small" 
                                    color="error"
                                    sx={{ fontSize: '0.6rem', height: '18px', fontWeight: 'bold' }}
                                  />
                                )}
                              </Box>
                            </Box>
                            <Typography variant="body2" sx={{ fontSize: '0.85rem', ml: 0.5 }}>
                              {comment.text}
                            </Typography>
                          </Box>
                        );
                      })
                    )}
                  </Paper>
                  
                  {/* コメント入力欄 */}
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <TextField
                      fullWidth
                      multiline
                      rows={2}
                      size="small"
                      value={newComment}
                      onChange={(e) => setNewComment(e.target.value)}
                      placeholder="コメントを入力してください"
                      variant="outlined"
                      onKeyPress={(e) => {
                        if (e.key === 'Enter' && !e.shiftKey) {
                          e.preventDefault();
                          handleAddComment();
                        }
                      }}
                    />
                    <Button 
                      variant="contained" 
                      onClick={handleAddComment}
                      disabled={!newComment.trim()}
                      sx={{ minWidth: '80px', height: 'fit-content' }}
                    >
                      送信
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal}>
            閉じる
          </Button>
          {loginInfo.authorityId === 'admin' && (
            <Button 
              onClick={handleSaveRequest} 
              variant="contained"
              disabled={saving}
            >
              {saving ? '保存中...' : '保存'}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default RequestDisplay;